import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  GetAllBranches,
  UpdatePriceListOrder,
  UpdateSortType,
  UpdateCompanyDisplayStatus,
} from "../../server/PriceList";
import { getStationsFromPGW } from "../../server/Station";

const PriceCompare = () => {
  const [companies, setCompanies] = useState([]);
  const [sortBy, setSortBy] = useState("manual");
  const [adminStation, setAdminStation] = useState(null);

  const { user, selectStation } = useSelector((state) => ({
    user: state.user.user,
    selectStation: state.user.stationId,
  }));

  useEffect(() => {
    if (!user) return;

    getStationsFromPGW()
      .then((x) => {
        const stations = x.data || [];
        const selected = stations.find(
          (s) => s.id === selectStation.toString(),
        );
        setAdminStation(selected || null);
      })
      .catch((err) => console.error("שגיאה בטעינת תחנות", err));
  }, [user, selectStation]);

  useEffect(() => {
    if (!user) return;
    if (!adminStation) return;

    GetAllBranches()
      .then((data) => {
        const companiesFromServer = data.companies || data;
        setSortBy(data.sortType || "manual");

        const formatted = companiesFromServer
          .map((c) => ({
            ...c,
            Name: `${c.retailerName} - ${c.branchName}`,
            isVisibleToCustomer: c.isVisibleToCustomer ?? true,
          }))
          .filter((c) => {
            const include = c.branchName !== adminStation.Name;
            return include;
          });

        setCompanies(formatted);
      })
      .catch((err) => console.error("שגיאה בטעינת החברות", err));
  }, [selectStation, adminStation, user]);

  const handleToggle = async (index, mode) => {
    const updated = companies.map((item, i) =>
      i === index ? { ...item, [mode]: !item[mode] } : item,
    );
    setCompanies(updated);

    const company = updated[index];
    try {
      await UpdateCompanyDisplayStatus(
        company,
        company.isVisibleToCustomer,
        localStorage.jwtToken,
        "hamazon",
      );
    } catch (err) {
      console.error("שגיאה בעדכון סטטוס תצוגה", err);
    }
  };

  const handleDragEnd = async (result) => {
    if (!result.destination || sortBy !== "manual") return;

    const reordered = Array.from(companies);
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);
    setCompanies(reordered);

    try {
      const orderedBranches = reordered.map((c) => `${c.retailer}-${c.branch}`);
      await UpdatePriceListOrder(orderedBranches);
    } catch (err) {
      console.error("שגיאה בעדכון סדר", err);
    }
  };

  const handleSortChange = async (e) => {
    const newSort = e.target.value;
    setSortBy(newSort);
    try {
      await UpdateSortType(newSort);
    } catch (err) {
      console.error("שגיאה בעדכון סוג המיון", err);
    }
  };

  return (
    <div className="price-compare">
      <h2>תצוגת חברות בהשוואת מחירים</h2>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "1rem",
        }}
      >
        <label htmlFor="sortSelect">מיון לפי:</label>
        <select id="sortSelect" value={sortBy} onChange={handleSortChange}>
          <option value="manual">סדר ידני</option>
          <option value="price">מחיר</option>
        </select>
      </div>

      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable
          droppableId="companyList"
          isDropDisabled={sortBy !== "manual"}
        >
          {(provided) => (
            <ul
              {...provided.droppableProps}
              ref={provided.innerRef}
              className="company-list"
            >
              {companies.map((company, index) => (
                <Draggable
                  key={`${company.retailer}-${company.branch}`}
                  draggableId={`${company.retailer}-${company.branch}`}
                  index={index}
                  isDragDisabled={sortBy !== "manual"}
                >
                  {(provided) => (
                    <li
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className="company-item"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "10px",
                        backgroundColor: "#f9f9f9",
                        borderBottom: "1px solid #ddd",
                        ...provided.draggableProps.style,
                      }}
                    >
                      <span className="company-name">{company.Name}</span>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <label>
                          <input
                            type="checkbox"
                            checked={company.isVisibleToCustomer}
                            onChange={() =>
                              handleToggle(index, "isVisibleToCustomer")
                            }
                          />
                          הצג בלקוח
                        </label>
                      </div>
                    </li>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default PriceCompare;
